module.exports = __webpack_public_path__ + "img/Polygon.6678ea12.svg";